<template>
  <div>
    <div class="box" v-if='fillingDeta.subjectType === 0'>
      <el-row>
        <el-col :span="3">
          <div class="box-t-l">
            <p>文件列表</p>
            <ul class="ull">
              <li v-for='(m, index) in fillingDeta.plandoc' :key="index" @click="getfile(m,index)" :class='{activess:activeli === index}'>
                <span slot="label" :title="formatPlanDoc(m.type)">
                {{formatPlanDoc(m.type)}}</span>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="box-pdf box-t-r">
            <pdf :src="srcaddress" :activeData="activeData" :canReupload="false"></pdf>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="box-t-rb">
            <el-tabs v-model="activeName2" type="card">
              <!-- <el-tab-pane label="备案信息" name="first">
                <p class="title">
                  <span>备案流水号： {{fillingDeta.serialCode}}</span>
                </p>
              </el-tab-pane> -->
              <el-tab-pane label="申报单位信息" name="second">
                <p>
                  <span>企业全称：</span>
                  <span>{{fillingDeta.subjectName}}</span>
                </p>
                <p>
                  <span>中心坐标：</span>
                  <span>东经：{{fillingDeta.longitude | formatDegree}}，北纬：{{fillingDeta.latitude | formatDegree}}</span>
                </p>
                <p>
                  <span>统一社会信用代码：</span>
                  <span>{{fillingDeta.code}}</span>
                </p>
                <p>
                  <span>行业：</span>
                  <span>{{ChangeName(fillingDeta.industry)}}</span>
                </p>
                <p class="flex flex-vc flex-hs">
                  <span>营业执照：</span>
                  <span @click="previewImg(fillingDeta.imgName)" class="a-hover relative">
                    <!-- 查看查看 -->
                    <viewer :images="photo" class="seeBigImg">
                      <img
                        v-for="(src,index) in photo"
                        :src="src"
                        :key="index"
                      >
                    </viewer>
                  </span>
                </p>
                <p>
                  <span>企业法人：</span>
                  <span>{{fillingDeta.legalPerson}}</span>
                </p>
                <p>
                  <span>联系电话：</span>
                  <span>{{fillingDeta.phone}}</span>
                </p>
                <p>
                  <span>注册地址：</span>
                  <span>{{fillingDeta.provinceName}} {{fillingDeta.cityName}} {{fillingDeta.countyName}} {{fillingDeta.address}}</span>
                </p>
                <p v-show="fillingDeta.zone">
                  <span>所属工业园区：</span>
                  <span>{{formatZone(fillingDeta.zone)}}</span>
                </p>
                <p>
                  <span>所属区划类型</span>
                  <span>{{formatRegionType(fillingDeta.regionType)}}</span>
                </p>
                <p>
                  <span>所属区划：</span>
                  <span v-html='getRegions(fillingDeta.regions)'></span>
                </p>
                <div v-if="fillingDeta.subjectType == 0 && fillingDeta.delegated == true">
                <p>
                  <span>编制单位名称：</span>
                  <span>{{fillingDeta.delegateOrgName}}</span>
                </p>
                <p>
                  <span>编制单位地址：</span>
                  <span>{{fillingDeta.delegateOrgAddr}}</span>
                </p>
                <p>
                  <span>编制单位联系人：</span>
                  <span>{{fillingDeta.delegateOrgLinkMan}}</span>
                </p>
                <p>
                  <span>编制单位联系电话：</span>
                  <span>{{fillingDeta.delegateOrgPhone}}</span>
                </p>
                </div>
              </el-tab-pane>
              <el-tab-pane label="预案概要" name="four">
                <digitization></digitization>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="box" v-if="fillingDeta.subjectType === 1 || fillingDeta.subjectType === 3 || fillingDeta.subjectType === 4">
      <el-row>
        <el-col :span="3">
          <div class="box-t-l">
            <p>文件列表</p>
            <ul class="ull">
              <li v-for='(m, index) in fillingDeta.plandoc' :key="index" @click="getfile(m,index)" :class='{activess:activeli === index}'>
                <span slot="label" :title="formatPlanDoc(m.type)">
                  {{formatPlanDoc(m.type)}}</span>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="box-pdf box-t-r">
            <pdf :src="srcaddress" :activeData="activeData" :canReupload="false"></pdf>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="box-t-rb">
            <el-tabs v-model="activeName2" type="card">
              <!-- <el-tab-pane label="备案信息" name="first">
                <p class="title">
                  <span>备案流水号： {{fillingDeta.serialCode}}</span>
                </p>
              </el-tab-pane> -->
              <el-tab-pane label="申报单位信息" name="second">
                <p>
                  <span>企业全称：</span>
                  <span>{{fillingDeta.subjectName}}</span>
                </p>
                <p>
                  <span>中心坐标：</span>
                  <span>东经：{{fillingDeta.longitude | formatDegree}}，北纬：{{fillingDeta.latitude | formatDegree}}</span>
                </p>
                <p>
                  <span>单位地址：</span>
                  <span>{{fillingDeta.address}}</span>
                </p>
                <p>
                  <span>所属区划：</span>
                  <span>{{getRegions(fillingDeta.regions)}}</span>
                </p>
                <p>
                  <span>联系人：</span>
                  <span>{{fillingDeta.linkMan}}</span>
                </p>
                <p>
                  <span>联系电话：</span>
                  <span>{{fillingDeta.phone}}</span>
                </p>
              </el-tab-pane>
              <el-tab-pane label="预案概要" name="four">
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="box" v-if='fillingDeta.subjectType === 2'>
      <el-row>
        <el-col :span="3">
          <div class="box-t-l">
            <p>文件列表</p>
            <ul class="ull">
              <li v-for='(m, index) in fillingDeta.plandoc' :key="index"  @click="getfile(m,index)" :class='{activess:activeli === index}'>
                <span slot="label" :title="formatPlanDoc(m.type)">
           {{formatPlanDoc(m.type)}}</span>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="box-pdf box-t-r">
            <pdf :src="srcaddress" :activeData="activeData" :canReupload="false"></pdf>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="box-t-rb">
            <el-tabs v-model="activeName2" type="card">
              <el-tab-pane label="备案信息" name="first">
                <p class="title">
                  <span>备案流水号： {{fillingDeta.serialCode}}</span>
                </p>
              </el-tab-pane>
              <el-tab-pane label="申报单位信息" name="second">
                <p>
                  <span>园区全称：</span>
                  <span>{{fillingDeta.subjectName}}</span>
                </p>
                <p>
                  <span>中心坐标：</span>
                  <span>东经：{{fillingDeta.longitude | formatDegree}}，北纬：{{fillingDeta.latitude | formatDegree}}</span>
                </p>
                <p>
                  <span>联系人：</span>
                  <span>{{fillingDeta.linkMan}}</span>
                </p>
                <p>
                  <span>联系电话：</span>
                  <span>{{fillingDeta.phone}}</span>
                </p>
                <p>
                  <span>注册地址：</span>
                  <span>{{fillingDeta.provinceName}} {{fillingDeta.cityName}} {{fillingDeta.countyName}} {{fillingDeta.address}}</span>
                </p>
                <!-- <p>
                  <span>所属工业园区：</span>
                  <span>{{formatZone(fillingDeta.zone)}}</span>
                </p> -->
                <p>
                  <span>所属区划类型</span>
                  <span>{{formatRegionType(fillingDeta.regionType)}}</span>
                </p>
                <p>
                  <span>所属区划：</span>
                  <span v-html='getRegions(fillingDeta.regions)'></span>
                </p>
              </el-tab-pane>
              <el-tab-pane label="预案概要" name="four">
                暂无信息
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="提示" v-model="dialogVisible" size="tiny">
      <img :src='imageSrc' width="100%" />
    </el-dialog>
  </div>
</template>
<script>
import fillingInfo from './../../data/basic/weather/filling'
// import pdf from './../../components/general/pdft.vue'
import pdf from './../../components/general/pdfNew.vue'
import numde from './../../components/weather/numberinfo.vue'
import digitization from './Digitization.vue'
export default {
  components: {
    digitization,
    pdf,
    numde
  },
  data() {
    return {
      activeName2: 'second',
      dialogVisible: false,
      imgshow: 1,
      planId: '',
      fillingDeta: {},
      imageSrc: '',
      none_box: false,
      activeli: 0,
      // 文件地址
      srcaddress: '',
      // 选中的数据
      activeData: {
        id: '',
        type: 1,
        value: ''
      },
      photo:[]
    }
},
    watch: {
        fillingDeta() {
          // 安全检查：确保plandoc存在且为数组
          if (!this.fillingDeta.plandoc || !Array.isArray(this.fillingDeta.plandoc) || this.fillingDeta.plandoc.length < 1) {
            console.log('plandoc数据为空或不存在');
            return
          } else {
            this.activeData.id = this.fillingDeta.plandoc[this.activeli].id
          }
        }
      },
      created() {
        this.planId = sessionStorage.planIdLists
        if (!this.planId) return
        this.fillingInfo({
          planId: this.planId
        })
        if (!sessionStorage.BoxState) return
      },
      methods: {
        ChangeName(val) {
          return val == null ? '未选择行业' : val.name
        },
        fillingInfo(data) {
          (async() => {
            let planInfo = await fillingInfo.get_fillingInfo(data)
            if (planInfo.status) {
              this.fillingDeta = planInfo.data
              //如果是企业
              if(this.fillingDeta.subjectType === 0){
                let simplifyFileTypeList = [1000,1001,1002];
                if(this.fillingDeta.simplifyFlag == 1 || this.fillingDeta.simplifyFlag == 0){
                  this.fillingDeta.plandoc = this.fillingDeta.plandoc.filter(doc => !simplifyFileTypeList.includes(doc.type));
                }else {
                  this.fillingDeta.plandoc = this.fillingDeta.plandoc.filter(doc => simplifyFileTypeList.includes(doc.type));
                }
              }

              if (this.fillingDeta.plandoc.length && this.fillingDeta.plandoc[0].id) {
                this.srcaddress = `/api/emer/plandoc/download?id=${this.fillingDeta.plandoc[0].id}&isOnline=true`
              }
              this.previewImg(this.fillingDeta.imgName)
            }
            this.none_box = true
          })()
        },

        previewImg(src, type, id) {
          let TOKEN = sessionStorage.getItem('publicToken')
          if (type) {
            if(id){
              this.imageSrc = `/api/emer/plandoc/download?id=${id}&isOnline=true`;
              this.photo[0] = this.imageSrc
            }
          } else {
              if (src) {
                  let arr = src.replace(/^;/,'').replace(/;$/,'').split(';')
                  if (arr.length == 1 && arr != '' && arr[0]) {
                      this.imageSrc = `/api/basic/img/get?name=${arr[0]}&AccessToken=${TOKEN}`
                      this.photo[0] = this.imageSrc
                  } else if (arr.length > 1 && arr[1]) {
                      this.imageSrc = `/api/basic/img/get?name=${arr[1]}&AccessToken=${TOKEN}`
                      this.photo[0] = this.imageSrc
                  } else {
                    this.imageSrc =  './../../../static/img/000.png'
                    this.photo[0] = this.imageSrc
                  }
              }else{
                  this.imageSrc =  './../../../static/img/000.png'
                  this.photo[0] = this.imageSrc
              }
          }
          // this.dialogVisible = true
        },
        formatZone(zone) {
          if (!zone) return '暂无工业园区'
          return zone.name
        },
        formatEaer(zone) {
          if (!zone) return ''
          return `${zone.provinceName},${zone.cityName},${zone.countyName}`
        },
        formatRegionType(regionType) {
          let regionName = ''
          switch (regionType) {
            case 1:
              regionName = '单个区县'
              break
            case 2:
              regionName = '跨区县'
              break
            case 3:
              regionName = '跨市'
              break
          }
          return regionName
        },
        downloadFiles(id) {
          if(id){
            window.location.href = `/api/emer/plandoc/download?id=${id}&isOnline=false`
          }
        },
        getRegions(regions) {
          if (!regions) return
          let regionsName = ''
          for (let i = 0; i < regions.length; i++) {
            regionsName += regions[i].province.name + ',' + regions[i].city.name + ','
            for (let k = 0; k < regions[i].county.length; k++) {
              if (regions[i].county[k].name) {
                regionsName += regions[i].county[k].name + ','
              }
            }
          }
          return regionsName.substring(0, regionsName.length - 1)
        },
     formatPlanDoc(num, filename) {
      let docName = ''
      switch (num) {
        case 1:
          docName = '备案表'
          break
        case 2:
          docName = '应急预案'
          break
        case 3:
          docName = '风险评估报告'
          break
        case 4:
          docName = '应急资源调查报告'
          break
        case 5:
          docName = '专家评审意见书'
          break
        case 6:
          docName = '补充其他（平面图等）'
          break
        case 7:
          docName = '审查意见书'
          break
        case 8:
          docName = '编制说明'
          break
        case 51:
          docName = '备案表'
          break
        case 52:
          docName = '应急预案'
          break
        case 53:
          docName = '专家评审意见书'
          break
        case 54:
          docName = '应急响应减排措施及现场核查表'
          break
        case 55:
          docName = '审查意见书'
          break
        case 1000:
          docName = '简化备案表'
          break
        case 1001:
          docName = '环境安全责任承诺卡'
          break
        case 1002:
          docName = '回顾性评估表'
          break
        case 98:
          docName = '其他 '
          break
        case 99:
          docName = '其他 '
          break
        default:
          docName = "其他 ";
          break;
      }
      return docName
    },
        //
        showImg(id, filename) {
          let file_name = /\.[^\.]+/.exec(filename)
          if (file_name[0] == '.pdf' || file_name[0] == '.png' || file_name[0] == '.jpg') {
            if (file_name[0] === '.pdf') {
              this.imgshow = 2
            } else {
              this.imgshow = 1
            }
          }
          return `/api/emer/plandoc/download?id=${id}&isOnline=true`
        },
        // 风险等级
        formatIndustryType(num) {
          let industryType = ''
          switch (num) {
            case 1:
              industryType = '一般'
              break
            case 2:
              industryType = '较大'
              break
            case 3:
              industryType = '重大'
              break
          }
          return industryType
        },
        // 形态
        formatIndustrystate(num) {
          let industryType = ''
          switch (num) {
            case 1:
              industryType = '固态'
              break
            case 2:
              industryType = '液态'
              break
            case 3:
              industryType = '气态'
              break
          }
          return industryType
        },
        // 形态
        formatIndustry(num) {
          let industryType = ''
          switch (num) {
            case 1:
              industryType = '学校'
              break
            case 2:
              industryType = '医院'
              break
            case 3:
              industryType = '村庄'
              break
            case 4:
              industryType = '社区'
              break
            case 5:
              industryType = '水源地'
              break
          }
          return industryType
        },
        // 文件下载
        getfile(val, index) {
          this.activeData = val
          this.activeli = index
          if(val.id){
            this.srcaddress = `/api/emer/plandoc/download?id=${val.id}&isOnline=true`
          }
        }
      }
  }

</script>
<style lang="stylus" scoped>
.box {
  position: relative; // bottom: 20px;
  box-sizing: border-box; // height: 1000px;
  // height:100%;
  margin: 0 auto;
  overflow: hidden;
}

.box-pdf {
  border: solid 1px #d1dbe5;
  height: 600px;
}

.box-t-l {
  box-sizing: border-box;
  ul li {
    cursor: pointer;

    border: 1px solid transparent;
    text-align: left;
    // padding: 10px;
      height:40px;
      line-height: 40px;
       box-sizing: border-box;
    width: 90%;
    span {
      font-size: 14px;
      padding-left: 5px;
    }
  }
}

.box-t-rb {
  padding-left: 10px;
  p {
    padding-left: 10px;
    line-height: 35px;
    span {
      font-size: 14px;
    }
  }
}

.activess {
  background-color: #fff;
  box-sizing: border-box;
  border-bottom-color: #fff!important;
  border-radius: 4px 4px 0 0;
  position: relative;
  span {
    color: #20a0ff;
  }
}

.text_red {
  color: red;
}

.activess2 {
  color: rgb(26, 250, 41) !important;
}

.box-b {
  padding: 10px;
  height: 100px;
  p {
    margin-top: 15px;
  }
}

.errTips {
  color: red;
}

.a-hover {
  color: #409eff;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.head-title {
  border-bottom: none!important
}

.relative {
  position:relative;
}

.flex {
    display: flex;
    flex-wrap: wrap;
}

.flex-vc {
    align-items: center;
}

.flex-hs {
    justify-content: flex-start;
}

.seeBigImg {
  width:80px;
}

.seeBigImg img {
  width:100%;
  height:100%;
}

</style>



// WEBPACK FOOTER //
// BurstfillInfo.vue?0f00a30c